import getStaticFile from '@helpers/bucket';

const LIGHT_THEME_PATH = 'icons/lightTheme/warranties';
const DARK_THEME_PATH = 'icons/darkTheme/warranties';

const icon = (path: string, fileName: string) => getStaticFile({ path, fileName });

export const PrivateLabel = {
  alt: 'Garantia de produtos MadeiraMadeira',
  light: {
    src: icon(LIGHT_THEME_PATH, 'private-label-warranty-badge.svg'),
    height: 24,
    width: 24,
  },
  blackFriday: {
    src: icon(DARK_THEME_PATH, 'private-label-warranty-badge.svg'),
    height: 24,
    width: 24,
  },
  dark: {
    src: icon(DARK_THEME_PATH, 'private-label-warranty-badge.svg'),
    height: 24,
    width: 24,
  },
};

export const Test100Days = {
  alt: 'Teste por 100 noites',
  light: {
    src: icon(LIGHT_THEME_PATH, 'test-100-days-warranty.svg'),
    height: 48,
    width: 48,
  },
  blackFriday: {
    src: icon(DARK_THEME_PATH, 'test-100-days-warranty.svg'),
    height: 48,
    width: 48,
  },
  dark: {
    src: icon(DARK_THEME_PATH, 'test-100-days-warranty.svg'),
    height: 48,
    width: 48,
  },
};

export const ExtendedWarranty = {
  alt: 'Garantia estendida',
  light: {
    src: icon(LIGHT_THEME_PATH, 'extended-warranty-badge.svg'),
    height: 26,
    width: 24,
  },
  blackFriday: {
    src: icon(DARK_THEME_PATH, 'extended-warranty-badge.svg'),
    height: 26,
    width: 24,
  },
  dark: {
    src: icon(DARK_THEME_PATH, 'extended-warranty-badge.svg'),
    height: 26,
    width: 24,
  },
};

export const ProductLine2years = {
  alt: '2 anos de garantia',
  light: {
    src: icon(LIGHT_THEME_PATH, 'flag-product-line-2years.svg'),
    height: 56,
    width: 60,
  },
  blackFriday: {
    src: icon(DARK_THEME_PATH, 'flag-product-line-2years.svg'),
    height: 56,
    width: 60,
  },
  dark: {
    src: icon(DARK_THEME_PATH, 'flag-product-line-2years.svg'),
    height: 56,
    width: 60,
  },
};

export const ProductLine2yearsMobile = {
  alt: '2 anos de garantia',
  light: {
    src: icon(LIGHT_THEME_PATH, 'flag-product-line-2years-mobile.jpg'),
    height: 23,
    width: 51,
  },
  blackFriday: {
    src: icon(DARK_THEME_PATH, 'flag-product-line-2years-mobile.jpg'),
    height: 23,
    width: 51,
  },
  dark: {
    src: icon(DARK_THEME_PATH, 'flag-product-line-2years-mobile.jpg'),
    height: 23,
    width: 51,
  },
};

export const ProductLine5years = {
  alt: '5 anos de garantia',
  light: {
    src: icon(LIGHT_THEME_PATH, 'flag-product-line-5years.svg'),
    height: 56,
    width: 60,
  },
  blackFriday: {
    src: icon(DARK_THEME_PATH, 'flag-product-line-5years.svg'),
    height: 56,
    width: 60,
  },
  dark: {
    src: icon(DARK_THEME_PATH, 'flag-product-line-5years.svg'),
    height: 56,
    width: 60,
  },
};

export const ProductLine5yearsMobile = {
  alt: '5 anos de garantia',
  light: {
    src: icon(LIGHT_THEME_PATH, 'flag-product-line-5years-mobile.jpg'),
    height: 23,
    width: 51,
  },
  blackFriday: {
    src: icon(DARK_THEME_PATH, 'flag-product-line-5years-mobile.jpg'),
    height: 23,
    width: 51,
  },
  dark: {
    src: icon(DARK_THEME_PATH, 'flag-product-line-5years-mobile.jpg'),
    height: 23,
    width: 51,
  },
};
